<template>
    <router-link :to="{ name: route, params: { id: value } }" class="c-btn c-btn--tiny c-btn--secondary no-margin">Bekijken</router-link>
</template>

<script>
import Column from '@mixins/Column';

export default {
    mixins: [ Column ],
    props: {
        route: {
            type: String,
            required: true
        }
    }
}
</script>
